module.exports = __webpack_public_path__ + "img/other_samsung1.9800088a.jpg";